module.exports = "/_next/static/images/WaysToUseDataToEngageYourCustomers-90ab0a984ae08fd1ecf5e70cfff82ff1.png";